export default __webpack_public_path__ + "4e2e7f1f4e39dcf81c3f9cc834a1d3a0.jpg";